module.exports = __webpack_public_path__ + "assets/images/tanker.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/tanker.png
// module id = 259
// module chunks = 1